// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* RTL/LTR global styles are imported from src/index.js, NOT from here.
   A plain .css file cannot pull an .scss file through sass-loader: css-loader
   resolves the @import and parses the result as plain CSS, so the SCSS
   (// comments, @use, nesting) fails with "Unknown word". Keep the SCSS
   import in JavaScript so the sass-loader chain compiles it. */

/* Allow dropdowns to escape table-responsive clipping */
.table-responsive {
  overflow-x: auto !important;
  overflow-y: visible !important;
}

/* Fix for transaction badge icons - ensure SVG and text are on same line */
/* This must come AFTER the global SVG reset that sets display: block */
table.CustomerTransactionHistory_transactionsTable__bqQVH td .CustomerTransactionHistory_transactionBadge__sycpA {
  display: inline-flex !important;
  align-items: center !important;
  white-space: nowrap !important;
  gap: 0.25rem;
}

table.CustomerTransactionHistory_transactionsTable__bqQVH td .CustomerTransactionHistory_transactionBadge__sycpA svg {
  display: inline-block !important;
  vertical-align: middle !important;
  flex-shrink: 0;
  width: 1em !important;
  height: 1em !important;
  line-height: 1 !important;
}

.poppins-thin {
  font-family: "Poppins", sans-serif;
  font-weight: 100;
  font-style: normal;
}

.poppins-extralight {
  font-family: "Poppins", sans-serif;
  font-weight: 200;
  font-style: normal;
}

.poppins-light {
  font-family: "Poppins", sans-serif;
  font-weight: 300;
  font-style: normal;
}

.poppins-regular {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  font-style: normal;
}

.poppins-medium {
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  font-style: normal;
}

.poppins-semibold {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-style: normal;
}

.poppins-bold {
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-style: normal;
}

.poppins-extrabold {
  font-family: "Poppins", sans-serif;
  font-weight: 800;
  font-style: normal;
}

.poppins-black {
  font-family: "Poppins", sans-serif;
  font-weight: 900;
  font-style: normal;
}

.poppins-thin-italic {
  font-family: "Poppins", sans-serif;
  font-weight: 100;
  font-style: italic;
}

.poppins-extralight-italic {
  font-family: "Poppins", sans-serif;
  font-weight: 200;
  font-style: italic;
}

.poppins-light-italic {
  font-family: "Poppins", sans-serif;
  font-weight: 300;
  font-style: italic;
}

.poppins-regular-italic {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  font-style: italic;
}

.poppins-medium-italic {
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  font-style: italic;
}

.poppins-semibold-italic {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-style: italic;
}

.poppins-bold-italic {
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-style: italic;
}

.poppins-extrabold-italic {
  font-family: "Poppins", sans-serif;
  font-weight: 800;
  font-style: italic;
}

.poppins-black-italic {
  font-family: "Poppins", sans-serif;
  font-weight: 900;
  font-style: italic;
}

.text-error {
  color: #d64848 !important;
  font-size: 0.65rem !important;
  font-weight: 700;
}

/* Create New Earning Rule Button - Global Override */
.earning-rule-create-btn {
  all: unset !important;
  box-sizing: border-box !important;
  display: inline-flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 10px !important;
  padding: 14px 24px !important;
  background: linear-gradient(135deg, #007BFF 0%, #0056b3 100%) !important;
  border: 2px solid #007BFF !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  font-size: 14px !important;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif !important;
  border-radius: 12px !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
  white-space: nowrap !important;
  outline: none !important;
  position: relative !important;
  overflow: hidden !important;
  min-height: 48px !important;
  box-shadow: 0 2px 12px rgba(0, 123, 255, 0.15) !important;
  text-decoration: none !important;
  cursor: pointer !important;
}

.earning-rule-create-btn:hover {
  background: linear-gradient(135deg, #0056b3 0%, #004494 100%) !important;
  border-color: #0056b3 !important;
  color: #ffffff !important;
  transform: translateY(-3px) scale(1.03) !important;
  box-shadow: 0 10px 30px rgba(0, 123, 255, 0.35) !important;
}

.earning-rule-create-btn:active {
  transform: translateY(-1px) scale(1.01) !important;
  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.25) !important;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;;+DAI+D;;AAE/D,wDAAwD;AACxD;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA,2EAA2E;AAC3E,uEAAuE;AACvE;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,qDAAqD;AACrD;EACE,qBAAqB;EACrB,iCAAiC;EACjC,+BAA+B;EAC/B,8BAA8B;EAC9B,8BAA8B;EAC9B,kCAAkC;EAClC,oBAAoB;EACpB,6BAA6B;EAC7B,wEAAwE;EACxE,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,2FAA2F;EAC3F,8BAA8B;EAC9B,4DAA4D;EAC5D,8BAA8B;EAC9B,wBAAwB;EACxB,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;EAC3B,yDAAyD;EACzD,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,wEAAwE;EACxE,gCAAgC;EAChC,yBAAyB;EACzB,kDAAkD;EAClD,0DAA0D;AAC5D;;AAEA;EACE,kDAAkD;EAClD,yDAAyD;AAC3D","sourcesContent":["/* RTL/LTR global styles are imported from src/index.js, NOT from here.\n   A plain .css file cannot pull an .scss file through sass-loader: css-loader\n   resolves the @import and parses the result as plain CSS, so the SCSS\n   (// comments, @use, nesting) fails with \"Unknown word\". Keep the SCSS\n   import in JavaScript so the sass-loader chain compiles it. */\n\n/* Allow dropdowns to escape table-responsive clipping */\n.table-responsive {\n  overflow-x: auto !important;\n  overflow-y: visible !important;\n}\n\n/* Fix for transaction badge icons - ensure SVG and text are on same line */\n/* This must come AFTER the global SVG reset that sets display: block */\ntable.CustomerTransactionHistory_transactionsTable__bqQVH td .CustomerTransactionHistory_transactionBadge__sycpA {\n  display: inline-flex !important;\n  align-items: center !important;\n  white-space: nowrap !important;\n  gap: 0.25rem;\n}\n\ntable.CustomerTransactionHistory_transactionsTable__bqQVH td .CustomerTransactionHistory_transactionBadge__sycpA svg {\n  display: inline-block !important;\n  vertical-align: middle !important;\n  flex-shrink: 0;\n  width: 1em !important;\n  height: 1em !important;\n  line-height: 1 !important;\n}\n\n.poppins-thin {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 100;\n  font-style: normal;\n}\n\n.poppins-extralight {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 200;\n  font-style: normal;\n}\n\n.poppins-light {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 300;\n  font-style: normal;\n}\n\n.poppins-regular {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n}\n\n.poppins-medium {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 500;\n  font-style: normal;\n}\n\n.poppins-semibold {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 600;\n  font-style: normal;\n}\n\n.poppins-bold {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 700;\n  font-style: normal;\n}\n\n.poppins-extrabold {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 800;\n  font-style: normal;\n}\n\n.poppins-black {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 900;\n  font-style: normal;\n}\n\n.poppins-thin-italic {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 100;\n  font-style: italic;\n}\n\n.poppins-extralight-italic {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 200;\n  font-style: italic;\n}\n\n.poppins-light-italic {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 300;\n  font-style: italic;\n}\n\n.poppins-regular-italic {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 400;\n  font-style: italic;\n}\n\n.poppins-medium-italic {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 500;\n  font-style: italic;\n}\n\n.poppins-semibold-italic {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 600;\n  font-style: italic;\n}\n\n.poppins-bold-italic {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 700;\n  font-style: italic;\n}\n\n.poppins-extrabold-italic {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 800;\n  font-style: italic;\n}\n\n.poppins-black-italic {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 900;\n  font-style: italic;\n}\n\n.text-error {\n  color: #d64848 !important;\n  font-size: 0.65rem !important;\n  font-weight: 700;\n}\n\n/* Create New Earning Rule Button - Global Override */\n.earning-rule-create-btn {\n  all: unset !important;\n  box-sizing: border-box !important;\n  display: inline-flex !important;\n  flex-direction: row !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 10px !important;\n  padding: 14px 24px !important;\n  background: linear-gradient(135deg, #007BFF 0%, #0056b3 100%) !important;\n  border: 2px solid #007BFF !important;\n  color: #ffffff !important;\n  font-weight: 700 !important;\n  font-size: 14px !important;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif !important;\n  border-radius: 12px !important;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  white-space: nowrap !important;\n  outline: none !important;\n  position: relative !important;\n  overflow: hidden !important;\n  min-height: 48px !important;\n  box-shadow: 0 2px 12px rgba(0, 123, 255, 0.15) !important;\n  text-decoration: none !important;\n  cursor: pointer !important;\n}\n\n.earning-rule-create-btn:hover {\n  background: linear-gradient(135deg, #0056b3 0%, #004494 100%) !important;\n  border-color: #0056b3 !important;\n  color: #ffffff !important;\n  transform: translateY(-3px) scale(1.03) !important;\n  box-shadow: 0 10px 30px rgba(0, 123, 255, 0.35) !important;\n}\n\n.earning-rule-create-btn:active {\n  transform: translateY(-1px) scale(1.01) !important;\n  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.25) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
